import React, { useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import { array } from 'prop-types'
import { SimpleCard } from './SimpleCard'
import EmblaCarousel from 'embla-carousel'

const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.white};
	width: 100%;

	.embla {
		overflow: hidden;
	}
	.embla__container {
		display: flex;
		margin-right: 100px;

		${({ theme }) => theme.MQ.M} {
			margin-right: 0;
			transform: none !important;
		}
	}
	.embla__slide {
		flex: 0 0 100%;
		margin-right: 2rem;
		position: relative;

		${({ theme }) => theme.MQ.M} {
			flex: 0 1 100%;

			&:last-child {
				margin-right: 0;
			}
		}
	}
`
const Section = styled.section`
	&:nth-of-type(odd) {
		background-color: ${({ theme }) => theme.colors.gray[100]};
	}
`
const SectionContainer = styled.div`
	${({ theme }) => theme.maxWidth.L};
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 0 auto;
	padding: 1rem 0 3rem;
	width: 95%;

	span {
		${({ theme }) => theme.fonts.bold};
	}
	li {
		margin: 1rem 0;

		&::marker {
			color: ${({ theme }) => theme.colors.secondary};
		}
	}
`
const SectionTitle = styled.h2`
	${({ theme }) => theme.fonts.primarySemiBold};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 2.375rem;
	letter-spacing: 0;
	line-height: 57px;
`
const SimpleCardWrapper = styled.div`
	display: flex;
`

BuyingGuideSection.propTypes = {
	sections: array,
	services: array,
}

/**
 * Buying Guide section for Top Five QT Landing Page Template
 * Consists of 3 sections and top 3 services
 *
 * @param {Array} props.sections - array of sections
 * @param {Array} props.services - array of services
 */
export function BuyingGuideSection({ sections, services }) {
	const emblaRef = useRef()

	useEffect(() => {
		// Because we have 2 sections containing images we want to use Embla carousel on, we have to go about querying for the dom nodes this way and creating an EmblaCarousel instance for each one instead of simply using the useEmblaCarousel hook Embla provides
		const emblaNodes = document.querySelectorAll('.embla')
		const emblas = Array.from(emblaNodes).map((node) => {
			EmblaCarousel(node)
		})
		return () => {
			emblas.map((embla) => embla.destroy())
		}
	}, [])
	return (
		<Wrapper>
			{sections.map(({ content, id, showTopThreeCards, title }) => (
				<Section key={id}>
					<SectionContainer>
						<SectionTitle>{title}</SectionTitle>
						{showTopThreeCards && (
							<div className="embla" ref={emblaRef}>
								<SimpleCardWrapper className="embla__container">
									{services.map((service) => (
										<SimpleCard key={service.id} service={service} />
									))}
								</SimpleCardWrapper>
							</div>
						)}
						<div dangerouslySetInnerHTML={{ __html: content }} />
					</SectionContainer>
				</Section>
			))}
		</Wrapper>
	)
}
